(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-sitenav-cable-locks"]) return;
  try {
    

  jQuery(document).ready(function(){

    var stickyNav = $('#lp-sitenav');   
    var viewMobile = ($(window).width() >= 576);
    var viewTablet = ($(window).width() > 768);
    var viewLaptop = ($(window).width() > 992);
    var navSection = '#shopify-section-lp-sitenav-cable-locks'; 
    var navHeader = '#shopify-section-header';    

    if (viewTablet) {

      // Tablet View or Larger
    
      $(window).scroll(function () { 

        // Scroll pass 406px
        if ($(this).scrollTop() >= 406 ) {
          // Append to Header and make it sticky
          stickyNav.detach().removeClass('appendOnly').addClass('fixed').appendTo(navHeader); 
        } else {
          // Detatch and and make it un-sticky
          stickyNav.detach().removeClass('appendOnly').removeClass('fixed').appendTo(navSection);
        }
      });    
    } else { 
      
      // Smaller than Tablet View
 
      $(window).scroll(function () {  

        // Scroll pass 60px  
        if ($(this).scrollTop() >= 60) {
          // Append to Header and make it sticky
          stickyNav.detach().removeClass('appendOnly').addClass('fixed').appendTo(navHeader); 
        } else {
          // Append to Header and make it un-sticky, please!
          stickyNav.detach().addClass('appendOnly').removeClass('fixed').appendTo(navHeader);
        }
      });
      
    }
  
  // Whenever window is resized, reload page
  // This helps the scrollTop functions render correctly
  $(window).resize(function() { 
    location.reload();
  });

}); 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-sitenav-privacy-screen"]) return;
  try {
    

  jQuery(document).ready(function(){

    var stickyNav = $('#lp-sitenav');   
    var viewMobile = ($(window).width() >= 576);
    var viewTablet = ($(window).width() > 768);
    var viewLaptop = ($(window).width() > 992);
    var navSection = '#shopify-section-lp-sitenav-privacy-screen';
    var navHeader = '#shopify-section-header';    

    if (viewTablet) {

      // Tablet View or Larger
    
      $(window).scroll(function () { 

        // Scroll pass 406px
        if ($(this).scrollTop() >= 625 ) {
          // Append to Header and make it sticky
          stickyNav.detach().removeClass('appendOnly').addClass('fixed').appendTo(navHeader); 
        } else {
          // Detatch and and make it un-sticky
          stickyNav.detach().removeClass('appendOnly').removeClass('fixed').appendTo(navSection);
        }
      });    
    } else { 
      
      // Smaller than Tablet View

      $(window).scroll(function () {  

        // Scroll pass 60px  
        if ($(this).scrollTop() >= 60) {
          // Append to Header and make it sticky
          stickyNav.detach().removeClass('appendOnly').addClass('fixed').appendTo(navHeader); 
        } else {
          // Append to Header and make it un-sticky, please!
          stickyNav.detach().addClass('appendOnly').removeClass('fixed').appendTo(navHeader);
        }
      });
      
    }
  
  // Whenever window is resized, reload page
  // This helps the scrollTop functions render correctly
  $(window).resize(function() { 
    location.reload();
  });

}); 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-slideshow"] && !window.DesignMode) return;
  try {
    

var speed = $('.tgs-main-banner-inner-wrap').attr('data-speed');
var autoplay = $('.tgs-main-banner-inner-wrap').attr('data-autoplay');
$('.slider_wrap').slick({
  infinite: true,
  autoplay: autoplay,
  focusOnSelect: true,
  autoplaySpeed: speed,
  draggable: true,
  cssEase: 'linear',
  lazyLoad: 'progressive',
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  accessibility: true,
  swipeToSlide: true,
  fade: true,
  pauseOnHover: true,
});


  } catch(e) { console.error(e); }
})();
      })();
